<template>
    <v-dialog scrollable v-model="dialog" max-width="800px">

        <v-dialog v-model="reasonDialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Motivo de Rechazo</span>
                </v-card-title>
                <v-card-text>
                    <v-textarea v-model="reason" label="Motivo de Rechazo" rows="4"></v-textarea>
                    <p class="text-caption text-grey">Por favor, escriba un motivo claro y detallado por el cual el Apto
                        Médico fue rechazado.</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="loadingRejection" color="secondary" @click="reasonDialog = false">Cancelar</v-btn>
                    <v-btn :loading="loadingRejection" dark color="primary" @click="rechazarAptoMedico()">Enviar</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>

        <v-card v-if="aptoMedico">
            <v-card-title>
                <span class="headline">{{ dialogTitle }}</span>
            </v-card-title>
            <v-card-text>

                <div v-if="aptoMedico.estado == 'APPROVED'">
                    <v-alert type="success" outlined v-show="true">
                        Apto Médico Aprobado
                    </v-alert>
                </div>

                <div v-if="aptoMedico.estado == 'REJECTED'">
                    <v-alert type="warning" outlined v-show="true">
                        Apto Médico Rechazado
                    </v-alert>
                    <v-alert type="warning" outlined v-show="true">
                        <p> Motivo del rechazo: </p>
                        <p>{{ aptoMedico.razon_rechazo }}</p>
                 
                    </v-alert>

                </div>

                <h4 class=" ">Vista Previa</h4>
                <div v-if="showFile">
                    <div v-if="aptoMedico.file_type != 'pdf'">
                        <p>Click en la imagen para ver</p>
                        <div class="images" v-viewer style="position: relative;">
                            <img  :key="downloadUrl":src="downloadUrl" :alt="aptoMedico.file_name"
                                :lazy-src="downloadUrl" :loading="true" class="clearence-image" />                          
                        </div>             
                        <a :href="downloadUrl" download :title="aptoMedico.file_name" class="download-link">
                            Descargar Imagen
                        </a>
                    </div>

                    <div v-if="downloadUrl && aptoMedico.file_type == 'pdf'">
                        <PDFViewer :source="downloadUrl" style="height: 600px; width: 100%" :controls="[]"
                            :loading-text="'Cargando Apto Médico...'" :rendering-text="'Renderizando Apto Médico...'"
                            @download="handleDownload"
                            @loading-failed="() => { console.log('Failed to load PDF'); alert('Failed to load PDF') }"
                            @rendering-failed="(e) => { console.log(e); console.log('Failed to render PDF'); alert('Failed to render PDF') }" />
                    </div>
                </div>

            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div v-if="aptoMedico.estado == 'PENDING'" style="text-align: right;">
                    <v-btn :disabled="loadingValidation" dark color="warning" @click="openRechazarAptoMedico()">
                        <v-icon left>close</v-icon> Rechazar Apto Médico
                    </v-btn>
                    <v-btn :loading="loadingValidation" dark color="green" @click="aprobarAptoMedico()">
                        <v-icon left>check</v-icon> Aprobar el Apto Médico
                    </v-btn>
                </div>
                <div v-if="aptoMedico.estado == 'APPROVED' || aptoMedico.estado == 'REJECTED'" style="text-align: right;">
                    <v-btn   dark color="primary"  @click="dialog = false">
                        <v-icon left>close</v-icon>
                    Cerrar
                    </v-btn>

                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import Vue from 'vue'
import api from '@/api/aptos'
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'
import CanAccess from '../../../../../components/utils/CanAccess.vue';
import LabelEstado from '../../../../../components/common/LabelEstado.vue';
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

Vue.use(VueViewer)
export default {
    props: {
        evento_id: {
            type: Number
        }
    },
    components: { CanAccess: CanAccess, LabelEstado: LabelEstado, PDFViewer: PDFViewer },
    data() {
        return {
            showFile: false,
            dialog: false,
            dialogTitle: 'Validar Apto Médico',
            aptoMedico_id: null,
            aptoMedico: null,
            loadingValidation: false,
            loadingRejection: false,
            reasonDialog: false,
            reason: ''
        }
    },
    computed: {
        downloadUrl() {
            return this.aptoMedico ?
                process.env.VUE_APP_BACKEND_API_URL + `evento/${this.evento_id}/aptos-medicos/${this.aptoMedico.id}/${this.aptoMedico.file_name}` : null;
        },
    },
    watch: {
        dialog: function (val) {
            if (!val) {
                this.aptoMedico = null;
                this.showFile = true;
                this.$emit('close');
            }
        }
    },
    methods: {
        openRechazarAptoMedico() {
            this.reasonDialog = true;
        },

        handleDownload(e) {
            console.log('Download event triggered', e);
        },
        openValidarAptoMedico(item) {
            this.aptoMedico = null;
            this.dialogTitle = 'Validar apto médico';
            this.aptoMedico = item;
            this.dialog = true;

            this.$nextTick(() => {
                this.showFile = true;
            });
        },
        rechazarAptoMedico() {
            this.loadingRejection = true;
            api.rechazarAptoMedico(this.aptoMedico.id, { reason: this.reason }).then((response) => {
                this.loadingRejection = false;
                this.$emit('reload', this.aptoMedico);
                this.dialog = false;
                this.aptoMedico = null;
            }).finally(() => {
                this.loadingRejection = false;
                this.reasonDialog = false;
                this.reason = '';
            })
            .catch((error) => {
                this.loadingRejection = false;
                this.reasonDialog = false;
                this.reason = '';
                console.log(error);
            })
        },


        aprobarAptoMedico() {
            this.loadingValidation = true;
            const currentDate = new Date().toISOString().split('T')[0]; // Get current date in YYYY-MM-DD format
            api.aprobarAptoMedico(this.aptoMedico.id, { medical_clearance_date: currentDate }).then((response) => {

                this.loadingValidation = false;
                this.$emit('reload', this.aptoMedico);
                this.dialog = false;
                this.aptoMedico = null;

            }).catch((error) => {
                console.log(error);
            });
        }


    }
}

</script>
<style scoped>
.clearence-image{
    cursor: pointer;
    margin: 0 auto;
     max-width: 100%; 
     max-height: 600px;
}
 
</style>